import React from 'react'
import { Redirect } from 'react-router-dom'
import { connect } from 'react-redux'
import withApp from '@brainstud/react-tbl/core/provider/withApp'
// TODO get appRoutes from provider
import { appRoutes } from '@brainstud/react-tbl/features'
import { routeTo, getBySlug, nextNavTo, prevNavTo } from '@brainstud/react-helpers'
// TODO move ui
// import { Page, Layout } from '@brainstud/schiphol-vtc-ui'
import { NavigationFooter, NavigationView } from '@brainstud/react-tbl/features/navigation'
import PageType from './types'

class PageView extends React.Component {
  render() {
    if(!this.props.page)
      return <Redirect to={routeTo(appRoutes, 'home')} />

    return (
      <NavigationView type="page" id={this.props.page.id}>
        <Page>
          <Layout toggleSidebar={this.props.app.toggleSidebar}>
            <PageType type={this.props.page.type} {...this.props} />

            <NavigationFooter
              title={`${this.props.navItem.prefix}. ${this.props.page.title}`}
              homeButton
              prevButton
              prevLabel="Vorige"
              prevTo={this.props.prevButtonTo}
              nextButton
              nextLabel="Volgende"
              nextTo={this.props.nextButtonTo} />
          </Layout>
        </Page>
      </NavigationView>
    )
  }
}

export default withApp(connect(
  (state, props) => {
    const navigation = state.navigation.list.byId
    const pages = state.pages.list.byId

    const page = getBySlug(pages, props.match.params.page)
    if(!page) return { page: false }

    const navItem = Object.values(navigation).find(item => item.pageId === page.id)

    const prevButtonTo = prevNavTo(state, navItem, appRoutes)
    const nextButtonTo = nextNavTo(state, navItem, appRoutes)

    return { navItem, page, nextButtonTo, prevButtonTo }
  },
  () => ({}),
)(PageView))
